"use strict";

const Ajaxinate = function (options) {
  const settings = options || {};
  const defaults = {
    pagination: ".AjaxinatePagination",
    method: "scroll",
    container: ".AjaxinateLoop",
    offset: 0,
    loadingText: "Loading",
    callback: null,
  };

  this.settings = Object.assign(defaults, settings);
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
  this.initialize();
};

window.Ajaxinate = Ajaxinate;

Ajaxinate.prototype.initialize = function () {
  if (!this.containerElement) return;

  const methods = {
    click: this.addClickListener,
    scroll: this.addScrollListeners,
  };

  methods[this.settings.method]();
};

Ajaxinate.prototype.addScrollListeners = function () {
  if (!this.paginationElement) return;

  document.addEventListener("scroll", this.checkIfPaginationInView);
  window.addEventListener("resize", this.checkIfPaginationInView);
  window.addEventListener("orientationchange", this.checkIfPaginationInView);
};

Ajaxinate.prototype.addClickListener = function () {
  if (!this.paginationElement) return;

  this.nextPageLinkElement = this.paginationElement.querySelector("a");
  this.clickActive = true;

  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
  }
};

Ajaxinate.prototype.stopMultipleClicks = function (event) {
  event.preventDefault();

  if (!this.clickActive) return;

  this.nextPageLinkElement.innerHTML = this.settings.loadingText;
  this.nextPageUrl = this.nextPageLinkElement.href;
  this.clickActive = false;
  this.loadMore();
};

Ajaxinate.prototype.checkIfPaginationInView = function () {
  const pagination_top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  const pagination_bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
  const pagination_is_visible = pagination_top <= window.innerHeight && pagination_bottom >= 0;

  if (!pagination_is_visible) return;

  this.nextPageLinkElement = this.paginationElement.querySelector("a");
  this.removeScrollListener();

  if (!this.nextPageLinkElement) return;

  this.nextPageLinkElement.innerHTML = this.settings.loadingText;
  this.nextPageUrl = this.nextPageLinkElement.href;
  this.loadMore();
};

Ajaxinate.prototype.loadMore = function () {
  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function () {
    if (this.request.readyState !== 4 || this.request.status !== 200) return;

    const new_container = this.request.responseXML.querySelectorAll(this.settings.container)[0];
    const new_pagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];

    this.containerElement.insertAdjacentHTML("beforeend", new_container.innerHTML);
    this.paginationElement.innerHTML = new_pagination.innerHTML;

    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

    if (this.settings.callback && typeof this.settings.callback === "function") {
      this.settings.callback(this.request.responseXML);
    }

    this.initialize();
  }.bind(this);

  this.request.open("GET", this.nextPageUrl);
  this.request.responseType = "document";
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function () {
  this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function () {
  document.removeEventListener("scroll", this.checkIfPaginationInView);
  window.removeEventListener("resize", this.checkIfPaginationInView);
  window.removeEventListener("orientationchange", this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function () {
  const methods = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener,
  };

  return methods[this.settings.method]();
};
